/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const CompositeContext = createContext({});
export const useCompositeContext = () => useContext(CompositeContext);
//# sourceMappingURL=context.js.map